import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

const getCurrentCDMXDate = () => {
  const d = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" }));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const getCurrentCDMXTime = () => {
  const d = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" }));
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const FilterProvider = ({ children }) => {
  const [notaSeleccionada, setNotaSeleccionada] = useState(null);
  const [notasSeleccionadas, setNotasSeleccionadas] = useState([]);
  const [avanzarSeleccionSignal, setAvanzarSeleccionSignal] = useState(0);
  const avanzarSeleccion = () => setAvanzarSeleccionSignal((prev) => prev + 1);
  const [searchTabValue, setSearchTabValue] = useState(0);
  const [searchNotasResults, setSearchNotasResults] = useState({
    notes: [],
    nextCursor: null,
  });

  const [editedNotaData, setEditedNotaData] = useState({
    titulo: '',
    contenido: '',
  });

  const [filterState, setFilterState] = useState({
    typeMedio: [],
    estado: [],
    nombreMedio: [],
    clasificacion: [],
    desdeFecha: getCurrentCDMXDate(),
    hastaFecha: getCurrentCDMXDate(),
    desdeHora: "",
    hastaHora: getCurrentCDMXTime(),
    modoBusqueda: "3",
    searchTypeByDate: "captura",
    palabraIncluir: "",
    palabraExcluir: "",
    consultaAvanzada: "",
    modoFormulario: "palabraClave",
    temaQuery: "",
    temaSeleccionado: "",
    subtemaSeleccionado: "",
  });

  const value = {
    notaSeleccionada, setNotaSeleccionada,
    notasSeleccionadas, setNotasSeleccionadas,
    avanzarSeleccionSignal, avanzarSeleccion,
    searchTabValue, setSearchTabValue,
    searchNotasResults, setSearchNotasResults,
    filterState, setFilterState,
    editedNotaData, setEditedNotaData,
  };

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error("useFilter debe ser usado dentro de un FilterProvider");
  }
  return context;
};